import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { CreateService } from '../services/create.service';
import { CreateDialogComponent } from './create-dialog/create-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UploadDialogComponent } from './upload-dialog/upload-dialog.component';
import { Toast, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-folder-listings-page',
  templateUrl: './folder-listings-page.component.html',
  styleUrls: ['./folder-listings-page.component.scss']
})
export class FolderListingsPageComponent {

  isMobile: boolean = false;
  userEmailId = this.storage.retrieve("userEmailId");
  allFolders: any = [];
  allFoldersFiltered: any = [];
  parent: any = '';
  isLoading: boolean = false;
  path: any = [];
  gridView: boolean = false;
  listView: boolean = true;
  ascSorted: boolean = false;
  descSorted: boolean = true;

  constructor(public router: Router,
    breakpointObserver: BreakpointObserver,
    private storage: LocalStorageService,
    private createService: CreateService,
    private dialog: MatDialog,
    private toastr: ToastrService) {
    breakpointObserver.observe([
      '(max-width: 767px)'
    ]).subscribe((result: { matches: boolean; }) => {
      this.isMobile = result.matches;
    });
    this.createService.getParentId().subscribe(res => this.parent = res);
    this.createService.setSelectedDestination(this.parent);
    if (this.parent.length == 0) {
      this.router.navigate(['home']);
    }
  }

  ngOnInit() {
    this.isLoading = true;
    this.createService.getDriveFiles(this.userEmailId, this.parent.id).subscribe({
      next: (data: any) => {
        this.allFolders = data;
        this.allFoldersFiltered = this.allFolders;
        this.isLoading = false;
      },
      error: (e: any) => {

      }
    });
    if (this.path.indexOf(this.parent) == -1) {
      this.path.push(this.parent);
    }
  }

  openFolder(folder: any, index?: any) {
    if (index != undefined) {
      console.log(index);
      this.path.length = index;
    }
    this.isLoading = true;
    this.createService.setSelectedDestination(folder);
    this.createService.getDriveFiles(this.userEmailId, folder.id).subscribe({
      next: (data: any) => {
        this.allFolders = data;
        for (let aF of this.allFolders) {
          aF.driveLink = "https://drive.google.com/file/d/" + aF.id + "/view"
        }
        if (this.path.indexOf(folder) == -1) {
          this.path.push(folder);
        }
        this.allFoldersFiltered = this.allFolders;
        console.log(this.path)
        this.isLoading = false;
      },
      error: (e: any) => {

      }
    })
  }

  openCreateDialog(type: any) {
    var selectedDestination: any;
    this.createService.getSelectedDestination().subscribe(res => selectedDestination = res);
    console.log(selectedDestination);
    const dialogRef = this.dialog.open(CreateDialogComponent, {
      data: { type: type, folder: selectedDestination }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result == true) {
        this.openFolder(selectedDestination)
      }
    });
  }

  openUploadDialog(type: any) {
    var selectedDestination: any;
    this.createService.getSelectedDestination().subscribe(res => selectedDestination = res);
    console.log(selectedDestination);
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      data: { type: type, folder: selectedDestination }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.openFolder(selectedDestination)
      }
    });
  }

  shortcutFile() {
    this.toastr.info("This resource cannot be assessed to create or upload files.");
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.allFoldersFiltered = this.allFolders.filter((aL: any) => aL.name.toLowerCase().includes(filterValue.toLowerCase()));
  }

  sortNamesAsc() {
    this.allFoldersFiltered.sort((a: any, b: any) => (a.name.trim() > b.name.trim()) ? 1 : ((b.name.trim() > a.name.trim()) ? -1 : 0))
    this.ascSorted = true;
    this.descSorted = false;
  }

  sortNamesDesc() {
    this.allFoldersFiltered.sort((a: any, b: any) => (b.name.trim() > a.name.trim()) ? 1 : ((a.name.trim() > b.name.trim()) ? -1 : 0))
    this.descSorted = true;
    this.ascSorted = false;
  }

  setViewStatus(status: string) {
    localStorage.setItem('viewStatus', status);
  }

  get isStatusGrid() {
    const status = localStorage.getItem('viewStatus') || 'list';
    return status === 'list' ? false : true
  }
  
}
